import { Controller } from '@hotwired/stimulus';

// Connects to data-controller="css"
export default class extends Controller {
  static classes = ['target'];
  static targets = ['content'];

  connect() {}

  toggle() {
    this.elements().forEach((t) => t.classList.toggle(this.targetClass));
  }

  add() {
    this.elements().forEach((t) => t.classList.add(this.targetClass));
  }

  remove() {
    this.elements().forEach((t) => t.classList.remove(this.targetClass));
  }

  elements() {
    return this.hasContentTarget ? this.contentTargets : [this.element];
  }
}
